export enum WorkerAction {
  MontecarloRetirement = 0,
}

export type RequestId = string;

export type TaskRequestMessage = {
  action: WorkerAction;
  uuid: string;
  serializedParams: string;
};

export enum TaskStatus {
  Complete = 0,
  Progressing,
  Failed,
}

export type TaskResponseMessage = {
  action: WorkerAction;
  uuid: string;
  status: TaskStatus;
  serializedResult: string;
  progress: number;
};
